import React from 'react';
import BrandCategoryLinks from './BrandCategoryLinks';
import BrandProductSlider from '../BrandProductSlider/BrandProductSlider';
import Product from '../Product/Product';

function BrandCategoryWithProducts({block, products, loading, getMessage}) {
  const gaParams = {
    productIds: products.map(product => product.ID),
    item_list_name: `Brand page ${block.title}`,
    item_list_id: `brand_page_${block.id}`,
  };

  return (
    <section className="portal-box max-w-[1600px] px-[20px] mx-auto mt-[60px] items-center min-1024:flex desktop:gap-[45px] lg:gap-[30px] phone:mt-[40px]">
      <div className="desktop:w-[560px] desktop:min-w-[560px] desktop:basis-[560px] min-1024:shrink-0 lg:w-[500px] lg:min-w-[500px] lg:basis-[500px] flex flex-col bg-[#000000] rounded-[12px] px-[30px] pt-[30px] 500:px-[20px] 500:pt-[20px]">
        <div className="title-section">
          {block.hideLink ? (
            <span className="text-[28px] text-white !font-['OtoiwoGroteskExtended'] font-semibold leading-normal phone:text-[20px] 500:!text-[18px]">
              {block.title}
            </span>
          ) : (
            <a href={block.url} className="border-b border-l-0 border-t-0 border-r-0 border-solid border-transparent pb-[2px] hover:border-white">
              <span className="text-[28px] text-white !font-['OtoiwoGroteskExtended'] font-semibold leading-normal phone:text-[20px] 500:!text-[18px]">
                {block.title}
              </span>
            </a>
          )}
        </div>

        {Array.isArray(block.descriptions) && block.descriptions.length > 0 &&
          block.descriptions.map((description, index) => (
            <p key={`brand-category-description-${block.id}-${index}`}
              className="text-[14px] font-normal leading-normal text-white mt-[20px] mb-0">
              {description}
            </p>
          ))
        }

        <BrandCategoryLinks block={block} getMessage={getMessage}/>

        {block.image?.src && (
          <a href={block.url} className="flex m-auto max-w-[366px] h-auto w-full">
            <img
              className="w-full h-full"
              src={block.image.src}
              alt={block.image.alt || block.title}
              title={block.image.title || block.title}
              width={block.image.width || undefined}
              height={block.image.height || undefined}
              loading="lazy"
              decoding="async"
            />
          </a>
        )}
      </div>

      <div className="min-w-0 flex-1">
        <BrandProductSlider
          title={block.title}
          totalTitle={getMessage('CATALOG_BRAND_CATEGORY_VIEW_ALL_TITLE')}
          totalLink={block.hideLink ? '' : block.url}
          gaParams={gaParams}
          loading={loading}
        >
          {products.map((product, index) => (
            <Product
              {...product}
              key={`brand-product-${block.id}-${product.ID}`}
              itemKey={`brand-product-${block.id}-${product.ID}`}
              gaParams={gaParams}
              last={index === products.length - 1}
              rootClassName={`relative flex flex-col shrink-0 w-[220px] py-8 px-3.5 border ${index !== products.length - 1 ? 'border-r-0' : ''} border-solid border-grey-5 desktop:basis-1/3 desktop:min-w-[33.333333%] desktop:max-w-[33.333333%] desktop:px-5`}
            />
          ))}
        </BrandProductSlider>
      </div>
    </section>
  );
}

export default BrandCategoryWithProducts;